export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/78489dd5fe22b2b724f99f5861a7cee7.svg";